<template>
<div >


  <div class="row vpad"> 
    <div class="col s12 yo-align-center"><img src="../assets/logo.png" style="height:240px;"/></div>
  </div>

<div class="title_h1 yo-color-primary" style="margin-top:30px;">REPORT ISCRITTI</div>


  <el-form ref="formBasic" :model="item.row" @submit.native.prevent="onSubmit" :rules="rulesForm" label-width="180px">
  
   <div class="row" style="margin-top:20px;">

      <div class="col s12 m6">
      <el-form-item label="Inserito dal" prop="inseritodal">
        <el-date-picker v-model="item.inseritodal" type="date" placeholder="Indica la data" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>
      </div>


      <div class="col s12 m6">
      <el-form-item label="Inserito al" prop="inseritoal">
        <el-date-picker v-model="item.inseritoal" type="date" placeholder="Indica la data" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>
      </div>



   </div>







      <div class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
         <div class="col s12 m3">
         &#160;
         </div> 
         <div class="col s12 m4 offset-m5">
         <el-button type="primary" @click="onSubmit" class="yo-bg-color-secondary" style="width:100%;border:none;">Report</el-button>
         </div>
      </div>



   </el-form>
</div>
</template>

<script>
import excel from '../excel'

export default {
  name: 'report-iscrizione',
  components: {

  },
  data() {
    return {
      loading:{}
      ,item:{inseritodal:'',inseritoal:''}
      ,sql:''
      
    }
  },
  created () {
   console.log("Arrivo al report-iscrizione.vue con id "+this.$route.params.id)

  },
  beforeDestroy () {
  },
  methods: {
   onSubmit: async function() {
    this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })

    var colonne = ['contatto.id AS id'
      ,'contatto.cognome AS cognome'
      ,'contatto.nome AS nome'
      ,'contatto.email AS email'
      ,'contatto.azienda AS azienda'
      ,'contatto.professione AS professione'
      /*
      ,'contatto.codicefiscale AS codicefiscale'
      ,'contatto.citta AS citta'
      ,'contatto.creditiecm AS creditiecm'
      ,'contatto.categoria AS categoria'
      ,'contatto.disciplina AS disciplina'
      */
      ,'contatto.inseritoil AS inseritoil'
   ]

      var where = []
      where.push('contatto.id>0')

      if(this.item.inseritodal.length>4) where.push('contatto.inseritoil>=→inseritodal')
      if(this.item.inseritoal.length>4) where.push('contatto.inseritoil<=→inseritoal')


    this.sql = 'SELECT '+colonne.join(',')+' FROM ccb_20211105.contatto WHERE '+where.join(' AND ')+' ORDER BY contatto.inseritoil,contatto.cognome,contatto.nome'
/*
    this.$axios.query('fetchAll',this.sql,this.item)


   },afterSubmit: async function() {
*/
    var wsSoci = excel.wsNew()
    wsSoci.cell(0,0,'REPORT ISCRIZIONI').cell(1,0,"Generato il "+this.$moment().format('DD MMMM YYYY[ alle ]HH:mm'))
    this.$axios.query('fetchAll',this.sql,this.item).then((data) => {
        //console.log(data.result)

        //var campi = ['address','cognome','nome','email','id','cellulare']
        //var labels = ['DATA INIZIO','MINUTI','IN AVVIO','ESITO','TIPO COSTO','COSTO','UTENTE','TEAMWORK','DESCRIZIONE']
        wsSoci.data(data.result,{initRow:7,labels:{ultimoanno:'Ultimo Anno'}})

        /*
        var col=0
        for (let label of labels)
          wsSoci.cell(7,col++,label)

        */
        this.loading.close()
        excel.wsClean().wscreate(wsSoci,'ISCRITTI').save() 
        

    })



    }

  },
  computed: {
    rulesForm:function() {
      var rulesNow = {

      }
      return rulesNow
    }
  }
}
</script>
<style>

</style>